export default "__VITE_ASSET__B08sLp12__"